// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"c338b3a8","162":"4a1aa10d","206":"7b792bac","425":"52ea97b0","549":"23b4f33e","580":"bbc5e363","635":"dd52da95","737":"c3f456b7","781":"a9f8d56f","832":"a43bf1aa","884":"3237d9fb","928":"cab470be","932":"e92c51b8"}[chunkId] + ".chunk.js";
};